<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->

    <!-- /.content-header -->

    <!-- Main content -->
    <section  class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">جدول انواع کتاب</h3>
                <div class="card-tools">
                  <div class="input-group input-group-sm insert_box">
                    <b-form-input v-model="searchName" placeholder="جستوجوی نوع کتاب"></b-form-input>
                    <button @click="showPostModal()" class="btn btn-success">
                      افزودن
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="!status">
              
                 <div v-if="Items" class="card-body table-responsive p-0">
                <STable
                  v-model="Items"
                  @showEditModal="showEditModal"
                  @deleteItem="deleteItem"
                  :headers="headers"
                />
              </div> 
                
              </template>
              <!-- /.card-header -->
              

              <!-- /.card-body -->
              <!-- <div class="card-footer">
                <b-button variant="warning"
                 @click="showDraggableTable()"
                >
الویت بندی
                </b-button>
              </div> -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <div class="d-flex justify-content-center" v-if="!status">
          <pagination
          v-if="fullData!=null"
            :data="fullData"
            @pagination-change-page="changePage"
            :disabled="status"
          ></pagination>
        </div>
      </div>
    </section>
    <Loading :show_loading="status" />
    <PostModal
    :title="'ویژگی '"

      @changeDisplayModal="showpModal = $event"
      :disabled="disabled"
      @submit="submit"
      :showPostModal="showpModal"
      :mode="mode"
      :edit_item="edit_item"
      :headers="headers"
    />

    <!-- /.content -->
  </div>
</template>
<script>
import PostModal from "@/components/mainComponent/postModal.vue";
import Loading from "@/components/admin/loading.vue";
import mixin from "../../mixins/mixins";
import STable from "@/components/mainComponent/STable.vue";
import {BFormInput} from "bootstrap-vue"
export default {
  components: {
    Loading,
    STable,
    PostModal,BFormInput
  },
  mixins: [mixin],  metaInfo() {
    return {
      title: " انواع کتاب",
    }
  },
  data() {
    return {
      searchName:null,
      routeKey: "bookTypes",
      showpModal: false,
      headers: [
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "نوع کتاب",
          type: "string",
          name: "نوع کتاب",
          key: "title"
        },
        
       
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "نمایش",
          type: "boolean",
          name: "وضعیت",
          key: "status"
        },
        {
          style:"col-12",
          show_in_tabel:true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          key: "",
          edit: true,
          delete: true
        }
      ],
      mode: "create",
     edit_item:null,
      current_url: "/admin/book-types",
      
    };
  },
  created() {
    if (this.Items == null) {
      
      this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        false,
        "",
        this.routeKey
      );
    }
  },
  methods: {
    showPostModal() {
      this.mode = "create";

      // this.$bvModal.show("postModal");
      this.showpModal = true;
    },
    
  },
  watch:{
    searchName(newVal){
      if(newVal == null||newVal==""||newVal==" "){
      this.$router.replace({ name: "bookType", query: {page: "1"} })

      }else{

        this.getItemsFromServer(this.current_url,1,true,`&searchBy1=title&search1=${newVal}`,this.routeKey)
      }
    }
  }
};
</script>
